export default class Popup {
  constructor(children) {
    this.children = children;
    this.popup = document.createElement('div');
    this.popup.classList.add('ac-map__popup');
  }

  open() {
    this.popup.classList.add('ac-map__popup--opened');
  }

  close() {
    this.popup.classList.remove('ac-map__popup--opened');
  }

  toggle() {
    if (this.popup.classList.contains('ac-map__popup--opened')) {
      this.close();
    } else {
      this.open();
    }
  }

  appendElement(element) {
    this.popup.appendChild(element);
  }

  render() {
    document.body.appendChild(this.popup);
  }
}
